import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal", "form", "title", "allCheckbox", "roleCheckbox"]

  open(event) {
    event.preventDefault()
    const button = event.currentTarget
    this.formTarget.action = button.dataset.url
    this.titleTarget.textContent = button.dataset.title || ""

    const roles = JSON.parse(button.dataset.roles || "[]")
    this.roleCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = roles.includes(checkbox.value)
    })
    this.syncAll()
    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  toggleAll() {
    const checked = this.allCheckboxTarget.checked
    this.roleCheckboxTargets.forEach((checkbox) => { checkbox.checked = checked })
  }

  syncAll() {
    this.allCheckboxTarget.checked = this.roleCheckboxTargets.every((checkbox) => checkbox.checked)
  }
}
